module.exports = __webpack_public_path__ + "static/media/UK-Lancaster.b96029c1.jpg";